//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { getIsSocialResponseEnabled } from '@legacy-components/nav3/navigation-menus/selectors/getIsSocialResponseEnabled';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const InboxNav = () => {
  // TODO: PD-239417 Remove feature flag after GA
  const isSocialResponseEnabled = useSelector(getIsSocialResponseEnabled);

  if (!isSocialResponseEnabled) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.SOCIAL_INBOX}
      state='socialresponse'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.INBOX_NAV}
    >
      Inbox
    </NavMenuItem>
  );
};
